module.exports = "{\n  \"version\": \"1.0.4\",\n  \"updateDate\": \"2025-07-04\"\n}\n";